<app-vvr-icon [dark]="false" [full]="false" [overlay]="false" [shadow]="false"></app-vvr-icon>
<div class="container">
    <div class="topbar">
        <div class="title">
            <h1 class="h3 condensed">Declaratie rapport</h1>
        </div>
        <div class="controls">
            <div
                class="fab small"
                id="btn-Exit"
                matTooltip="Terug naar overzicht"
                matTooltipPosition="below"
                routerLink="/{{Routenames.declarationRequest}}">
                <i class="fas fa-sign-out-alt"></i>
            </div>
        </div>
    </div>
    <div>
        <div class="pb-3">
            Gebruik de VVR app voor het invoeren van je declaraties.
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <mat-form-field class="status-filter">
                <mat-label>Periode</mat-label>
                <input [(ngModel)]="date" [matDatepicker]="dp" matInput>
                <mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
                <mat-datepicker
                    #dp
                    (monthSelected)="chosenMonthHandler($event, dp)"
                    panelClass="example-month-picker"
                    startView="year">
                </mat-datepicker>
            </mat-form-field>
            <div>
                <button color="primary" mat-raised-button routerLink="/{{Routenames.declarationTypes}}">
                    Types beheren
                </button>
            </div>
        </div>
        <div class="pt-3">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th (click)="sortList('name')" matRipple>
                            Medewerker
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="name"></app-sorting-icon>
                        </th>
                        <th (click)="sortList('email')" matRipple>
                            E-mailadres
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="email"></app-sorting-icon>
                        </th>
                        <th (click)="sortList('count')" class="text-right" matRipple matTooltip="Aantal declaraties">
                            Aantal
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="count"></app-sorting-icon>
                        </th>
                        <th (click)="sortList('status')" matRipple>
                            Status
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="status"></app-sorting-icon>
                        </th>
                        <th (click)="sortList('amount')" class="text-right" matRipple>
                            Bedrag
                            <app-sorting-icon [currentSort]="currentSort()" [desc]="desc()" property="amount"></app-sorting-icon>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of list(); track item) {
                        <tr>
                            <td>
                                {{item.name}}
                            </td>
                            <td>
                                {{item.email}}
                            </td>
                            <td class="text-right" matTooltip="Aantal declaraties">
                                {{item.count | number}} st
                            </td>
                            <td class="status-col">
                                <div>
                                  <span>
                                    {{item.status}}
                                  </span>
                                    @if (item.status_id == statusGoedgekeurd) {
                                        <button
                                            (click)="statusPayed(item)"
                                            mat-icon-button
                                            matTooltip="Zet op vergoed">
                                            <i class="fas fa-money-check-edit"></i>
                                        </button>
                                    }
                                </div>
                            </td>
                            <td class="text-right">
                                <span
                                    [cdkCopyToClipboard]="copyClip(item.amount)"
                                    class="curpoint"
                                    matTooltip="Kopieer bedrag"
                                    matTooltipPosition="before">
                                  {{item.amount | currency : 'EUR'}}
                                </span>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="99">
                                Geen declaraties gevonden
                            </td>
                        </tr>
                    }
                </tbody>
                <thead>
                    <tr>
                        <th class="text-right" colspan="4">

                        </th>
                        <th class="text-right">
                            Totaal: {{total | currency  : 'EUR'}}
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
    </div>
</div>
